module.exports = __webpack_public_path__ + "img/factory-swiper-3.cd2f939c.png";